import About from '@/app/components/About'
import Head from 'next/head'

export default function AboutPage() {
  return (
    <>
      <Head>
        <title>Azul Agro - Sobre Nós</title>
        <meta name="description" content="Saiba mais sobre a Azul Agro, nossa história, missão e valores. Descubra como estamos comprometidos em ajudar você a otimizar suas operações agrícolas com nossas soluções de alta performance." />
        <link rel="preload" as="image" href={"https://gabcomercio.azureedge.net/azul-agro/desktop/about/introSection.webp"} media="(min-width: 1140px)" />
        <link rel="preload" as="image" href={"https://gabcomercio.azureedge.net/azul-agro/tablet/about/introSection.webp"} media="(min-width: 540px) and (max-width: 1139px)" />
        <link rel="preload" as="image" href={"https://gabcomercio.azureedge.net/azul-agro/mobile/about/introSection.webp"} media="(max-width: 539px)" />
      </Head>
      <main>
        <About />
      </main>
    </>
  )
}
